import {
  CLEAR_ROUTES_REDUCER,
  CREATE_NEW_ROUTE_SUCCESS,
  DELETE_ROUTE,
  DELETE_ROUTE_SUCCESS,
  EDIT_ROUTE,
  COPY_ROUTE,
  CREATE_NEW_ROUTE,
  GET_ACTIVE_ROUTE_DETAILS,
  GET_ACTIVE_ROUTE_DETAILS_SUCCESS,
  GET_ACTIVE_ROUTE_DETAILS_FAILED,
  GET_INACTIVE_ROUTE_DETAILS,
  GET_INACTIVE_ROUTE_DETAILS_SUCCESS,
  GET_INACTIVE_ROUTE_DETAILS_FAILED,
  GET_ACTIVE_ROUTES_HISTORY_SUCCESS,
  GET_BUS_ROUTES_SUCCESS,
  GET_DETAILED_ACTIVE_ROUTE_HISTORY_FAILURE,
  GET_DETAILED_ACTIVE_ROUTE_HISTORY_SUCCESS,
  GET_DRIVER_ROUTES_SUCCESS,
  GET_ROUTE_BY_ID,
  GET_ROUTE_BY_ID_FAILURE,
  GET_ROUTE_BY_ID_SUCCESS,
  CLEAR_ROUTE_BY_ID,
  GET_ROUTE_CARRIERS_RELATIONS_SUCCESS,
  GET_ROUTE_HISTORY_STATIONS_STATS_FAILURE,
  GET_ROUTE_HISTORY_STATIONS_STATS_SUCCESS,
  GET_ROUTE_HISTORY_STUDENTS_STATS_FAILURE,
  GET_ROUTE_HISTORY_STUDENTS_STATS_SUCCESS,
  GET_TODAY_ROUTES,
  GET_TODAY_ROUTES_SUCCESS,
  HIDE_ROUTE_STATIONS_LOADER,
  HIDE_ROUTES_HISTORY_LOADER,
  SEARCH_ACTIVE_ROUTE_DELAYS_HISTORY_FAILURE,
  SEARCH_ACTIVE_ROUTE_DELAYS_HISTORY_SUCCESS,
  SEARCH_ACTIVE_ROUTE_LOCATIONS_HISTORY_FAILURE,
  SEARCH_ACTIVE_ROUTE_LOCATIONS_HISTORY_SUCCESS,
  SEARCH_ACTIVE_ROUTE_STATIONS_HISTORY_FAILURE,
  SEARCH_ACTIVE_ROUTE_STATIONS_HISTORY_SUCCESS,
  SEARCH_ACTIVE_ROUTE_STUDENTS_HISTORY_FAILURE,
  SEARCH_ACTIVE_ROUTE_STUDENTS_HISTORY_SUCCESS,
  SEARCH_ROUTES_SUCCESS,
  SET_BUS_ROUTES_LOADING,
  SET_DRIVER_ROUTES_LOADING,
  SET_ROUTE_HISTORY_DELAYS_LOADER,
  SET_ROUTE_HISTORY_DETAILS_LOADER,
  SET_ROUTE_HISTORY_LOCATIONS_LOADER,
  SET_ROUTE_HISTORY_STATIONS_LOADER,
  SET_ROUTE_HISTORY_STUDENTS_LOADER,
  SET_ROUTES_LOADING,
  SHOW_ROUTE_STATIONS_LOADER,
  SHOW_ROUTES_HISTORY_LOADER,
  UPDATE_EXISTING_SEARCH_ROUTES,
  UPDATE_RECENTLY_ADDED_ROUTE,
  GET_ACTIVE_ROUTE_DETAILS_INFO,
  GET_ACTIVE_ROUTE_DETAILS_INFO_SUCCESS,
  UPDATE_STATION_SUCCESS,
  UPDATE_STATION_FAILURE,
  TOGGLE_STATION_MODAL,
  TOGGLE_ROUTE_MODAL,
  ROUTE_MODAL_SUBMITED_SUCCESS,
  ROUTE_MODAL_SUBMITED_FAILURE,
  CREATE_NEW_ROUTE_STATION,
  DELETE_ROUTE_STATION,
  UPDATE_STATION,
  UPDATE_STATIONS_SCHEDULE,
  GET_CAMPUSES_FOR_ROUTES,
  GET_CAMPUSES_FOR_ROUTES_SUCCESS,
  GET_CAMPUSES_FOR_ROUTES_FAILURE,
  CLEAR_CAMPUSES_FOR_ROUTES,
  TOGGLE_COPY_ROUTE_MODAL,
  GET_LOG_ROUTE_DATA,
  GET_LOG_ROUTE_DATA_SUCCESS,
  GET_LOG_ROUTE_DATA_FAILURE,
  UPDATE_SELECTED_ROUTES,
  GET_ROUTE_STOP_DATA,
  GET_ROUTE_STOP_DATA_SUCCESS,
  GET_ROUTE_STOP_DATA_FAILURE,
  TERMINATE_ACTIVE_ROUTE_TOGGLE_CONFIRMATION_MODAL,
  TERMINATE_ACTIVE_ROUTE_SUCCESS,
  TERMINATE_ACTIVE_ROUTE_FAILED,
  ACTIVE_ROUTE_LOCATION_HISTORY_SUCCESS,
  ACTIVE_ROUTE_LOCATION_HISTORY_FAILURE,
  FETCH_ALL_ROUTES_PAGINATED,
  FETCH_ALL_ROUTES_PAGINATED_SUCCESS,
} from 'constants/ActionTypes';
import { ROUTE_BY_ID_MISSING } from 'constants/Values';
import { RequestStatus } from '../models/requestStatus';

const INIT_STATE = {
  activeRoutes: [],
  selectedRoutes: [],
  activeRoutesHistory: {
    items: [],
    loading: false,
    pageCount: 1,
  },
  activeRouteHistoryDelays: {
    items: [],
    loading: false,
    pageCount: 1,
  },
  activeRouteHistoryDetails: {
    data: {},
    loading: false,
  },
  activeRouteHistoryLocations: {
    items: [],
    loading: false,
    pageCount: 1,
  },
  activeRouteHistoryStations: {
    items: [],
    loading: false,
    pageCount: 1,
    statistics: {},
  },
  activeRouteHistoryStudents: {
    items: [],
    loading: false,
    pageCount: 1,
    statistics: {},
  },
  logRouteHistory: {
    entities: [],
    loading: false,
    pageCount: 1,
  },
  routeStopData: {
    entities: [],
    loading: false,
    pageCount: 1,
  },
  campuses: [],
  carriersRelations: [],
  activeRouteDetails: null,
  inactiveRouteDetails: null,
  driverRoutes: {},
  busRoutes: {},
  driverRoutesLoading: false,
  busRoutesLoading: false,
  listOfRoutes: [],
  lastRouteSearchTerm: '',
  loader: false,
  loaderActiveRouteDetails: false,
  loaderInActiveRouteDetails: false,
  recentlyAddedRoutes: [],
  routeByIdRequestStatus: new RequestStatus(),
  routeFetchedById: null,
  routeStationsUpdating: false,
  activeRouteDetailsInfo: {},
  isRouteModalOpen: false,
  isRouteModalLoading: false,
  isRouteStationModalOpen: false,
  isStationUpdatingLoading: false,
  isCopyRouteModalOpen: false,
  isTerminateActiveRouteModalOpen: false,
  fetchedRoutes: [],
  isFetchingRoutes: false,
};

const sortRouteStationByOrder = route => {
  if (route) {
    const sorted = { ...route };
    sorted.wayTo.sort((first, second) => first.stationOrder - second.stationOrder);
    sorted.wayBack.sort((first, second) => first.stationOrder - second.stationOrder);
    return sorted;
  }

  return null;
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CREATE_NEW_ROUTE_SUCCESS: {
      const recentlyAddedRoutes = [action.payload.route, ...state.recentlyAddedRoutes];
      return {
        ...state,
        recentlyAddedRoutes,
      };
    }
    case EDIT_ROUTE:
    case COPY_ROUTE: {
      return {
        ...state,
        isRouteModalLoading: true,
      };
    }
    case CREATE_NEW_ROUTE: {
      return {
        ...state,
        isRouteModalLoading: true,
      };
    }
    case DELETE_ROUTE: {
      return {
        ...state,
        isRouteModalLoading: true,
      };
    }
    case DELETE_ROUTE_SUCCESS: {
      const { routeId } = action.payload;
      const { listOfRoutes, recentlyAddedRoutes } = state;
      const isRecentlyAdded = recentlyAddedRoutes.findIndex(route => route.id === routeId) > -1;
      return {
        ...state,
        listOfRoutes: isRecentlyAdded
          ? listOfRoutes
          : listOfRoutes.filter(route => route.id !== routeId),
        recentlyAddedRoutes: isRecentlyAdded
          ? recentlyAddedRoutes.filter(route => route.id !== routeId)
          : recentlyAddedRoutes,
      };
    }
    case GET_ACTIVE_ROUTES_HISTORY_SUCCESS:
      return {
        ...state,
        activeRoutesHistory: {
          ...state.activeRoutesHistory,
          items: action.payload.items,
          pageCount: action.payload.pageCount,
        },
      };
    case GET_ROUTE_BY_ID:
      return {
        ...state,
        routeByIdRequestStatus: new RequestStatus(true),
      };
    case GET_ROUTE_BY_ID_FAILURE:
      return {
        ...state,
        routeByIdRequestStatus: new RequestStatus(false, false, action.payload.error),
        routeFetchedById: ROUTE_BY_ID_MISSING,
      };
    case GET_ROUTE_BY_ID_SUCCESS: {
      const route = sortRouteStationByOrder(action.payload.route);
      return {
        ...state,
        routeByIdRequestStatus: new RequestStatus(false, true),
        routeFetchedById: route,
      };
    }
    case CLEAR_ROUTE_BY_ID: {
      return {
        ...state,
        routeFetchedById: null,
      };
    }
    case GET_TODAY_ROUTES: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_TODAY_ROUTES_SUCCESS: {
      return {
        ...state,
        loader: false,
        activeRoutes: action.payload.activeRoutes,
      };
    }
    case GET_ACTIVE_ROUTE_DETAILS: {
      return {
        ...state,
        loaderActiveRouteDetails: true,
      };
    }
    case GET_ACTIVE_ROUTE_DETAILS_SUCCESS: {
      return {
        ...state,
        loaderActiveRouteDetails: false,
        activeRouteDetails: action.payload.activeRouteDetails,
      };
    }

    case GET_ACTIVE_ROUTE_DETAILS_FAILED: {
      return {
        ...state,
        loaderActiveRouteDetails: false,
        activeRouteDetails: null,
      };
    }

    case TERMINATE_ACTIVE_ROUTE_TOGGLE_CONFIRMATION_MODAL: {
      return {
        ...state,
        isTerminateActiveRouteModalOpen: !state.isTerminateActiveRouteModalOpen,
      };
    }
    case TERMINATE_ACTIVE_ROUTE_SUCCESS:
      return {
        ...state,
        activeRouteDetails: action.payload.activeRouteDetails,
        isTerminateActiveRouteModalOpen: false,
      };
    case TERMINATE_ACTIVE_ROUTE_FAILED: {
      return {
        ...state,
        isTerminateActiveRouteModalOpen: false,
      };
    }

    case GET_INACTIVE_ROUTE_DETAILS: {
      return {
        ...state,
        loaderInActiveRouteDetails: true,
      };
    }
    case GET_INACTIVE_ROUTE_DETAILS_SUCCESS: {
      return {
        ...state,
        loaderInActiveRouteDetails: false,
        inactiveRouteDetails: action.payload.inactiveRouteDetails,
        haveInactiveRouteDetails: true,
      };
    }

    case GET_INACTIVE_ROUTE_DETAILS_FAILED: {
      return {
        ...state,
        loaderInActiveRouteDetails: false,
        inactiveRouteDetails: null,
        haveInactiveRouteDetails: false,
      };
    }

    case GET_ACTIVE_ROUTE_DETAILS_INFO: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_ACTIVE_ROUTE_DETAILS_INFO_SUCCESS: {
      return {
        ...state,
        loader: false,
        activeRouteDetailsInfo: action.payload.activeRouteDetails,
      };
    }
    case GET_DETAILED_ACTIVE_ROUTE_HISTORY_FAILURE:
      return {
        ...state,
        activeRouteHistoryDetails: {
          ...state.activeRouteHistoryDetails,
          data: {},
        },
      };
    case GET_DETAILED_ACTIVE_ROUTE_HISTORY_SUCCESS:
      return {
        ...state,
        activeRouteHistoryDetails: {
          ...state.activeRouteHistoryDetails,
          data: action.payload.details,
        },
      };
    case SET_ROUTES_LOADING: {
      return {
        ...state,
        loader: action.payload.isLoading,
      };
    }
    case SEARCH_ROUTES_SUCCESS: {
      return {
        ...state,
        listOfRoutes: action.payload.routes,
        routesPageCount: action.payload.pageCount,
        loader: false,
        lastRouteSearchTerm: action.payload.routeSearchTerm,
      };
    }
    case FETCH_ALL_ROUTES_PAGINATED:
      return {
        ...state,
        isFetchingRoutes: true,
      };

    case FETCH_ALL_ROUTES_PAGINATED_SUCCESS:
      return {
        ...state,
        fetchedRoutes: action.payload.routes,
        isFetchingRoutes: false,
      };

    case GET_ROUTE_CARRIERS_RELATIONS_SUCCESS: {
      return {
        ...state,
        carriersRelations: action.payload.carriersRelations,
      };
    }
    case GET_ROUTE_HISTORY_STATIONS_STATS_FAILURE:
      return {
        ...state,
        activeRouteHistoryStations: {
          ...state.activeRouteHistoryStations,
          statistics: {},
        },
      };
    case GET_ROUTE_HISTORY_STATIONS_STATS_SUCCESS:
      return {
        ...state,
        activeRouteHistoryStations: {
          ...state.activeRouteHistoryStations,
          statistics: action.payload.statistics,
        },
      };
    case GET_ROUTE_HISTORY_STUDENTS_STATS_FAILURE:
      return {
        ...state,
        activeRouteHistoryStudents: {
          ...state.activeRouteHistoryStudents,
          statistics: {},
        },
      };
    case GET_ROUTE_HISTORY_STUDENTS_STATS_SUCCESS:
      return {
        ...state,
        activeRouteHistoryStudents: {
          ...state.activeRouteHistoryStudents,
          statistics: action.payload.statistics,
        },
      };
    case HIDE_ROUTE_STATIONS_LOADER: {
      return {
        ...state,
        routeStationsUpdating: false,
      };
    }
    case HIDE_ROUTES_HISTORY_LOADER: {
      return {
        ...state,
        activeRoutesHistory: {
          ...state.activeRoutesHistory,
          loading: false,
        },
      };
    }
    case UPDATE_EXISTING_SEARCH_ROUTES: {
      return {
        ...state,
        listOfRoutes: action.payload,
      };
    }
    case UPDATE_RECENTLY_ADDED_ROUTE: {
      const route = action.payload.data;
      return {
        ...state,

        recentlyAddedRoutes: state.recentlyAddedRoutes.map(
          item =>
            item.id === route.id
              ? {
                  id: route.id,
                  name: route.name,
                  number: route.number,
                  valid: item.valid,
                  newRoute: item.newRoute,
                }
              : item,
        ),
      };
    }
    case GET_BUS_ROUTES_SUCCESS: {
      return {
        ...state,
        busRoutes: {
          ...state.busRoutes,
          [action.payload.busId]: action.payload.busRoutes,
        },
      };
    }
    case GET_DRIVER_ROUTES_SUCCESS: {
      return {
        ...state,
        driverRoutes: {
          ...state.driverRoutes,
          [action.payload.driverId]: action.payload.driverRoutes,
        },
      };
    }
    case SEARCH_ACTIVE_ROUTE_DELAYS_HISTORY_FAILURE:
      return {
        ...state,
        activeRouteHistoryDelays: {
          ...state.activeRouteHistoryDelays,
          items: [],
          pageCount: 1,
        },
      };
    case SEARCH_ACTIVE_ROUTE_DELAYS_HISTORY_SUCCESS:
      return {
        ...state,
        activeRouteHistoryDelays: {
          ...state.activeRouteHistoryDelays,
          items: action.payload.delays,
          pageCount: action.payload.pageCount,
        },
      };
    case SEARCH_ACTIVE_ROUTE_LOCATIONS_HISTORY_FAILURE:
      return {
        ...state,
        activeRouteHistoryLocations: {
          ...state.activeRouteHistoryLocations,
          items: [],
          pageCount: 1,
        },
      };
    case SEARCH_ACTIVE_ROUTE_LOCATIONS_HISTORY_SUCCESS:
      return {
        ...state,
        activeRouteHistoryLocations: {
          ...state.activeRouteHistoryLocations,
          items: action.payload.locations,
          pageCount: action.payload.pageCount,
        },
      };
    case ACTIVE_ROUTE_LOCATION_HISTORY_FAILURE:
      return {
        ...state,
        activeRouteHistoryLocations: {
          ...state.activeRouteHistoryLocations,
          items: [],
        },
      };
    case ACTIVE_ROUTE_LOCATION_HISTORY_SUCCESS:
      return {
        ...state,
        activeRouteHistoryLocations: {
          ...state.activeRouteHistoryLocations,
          items: action.payload.locations,
        },
      };
    case SEARCH_ACTIVE_ROUTE_STATIONS_HISTORY_FAILURE:
      return {
        ...state,
        activeRouteHistoryStations: {
          ...state.activeRouteHistoryStations,
          items: [],
          pageCount: 1,
        },
      };
    case SEARCH_ACTIVE_ROUTE_STATIONS_HISTORY_SUCCESS:
      return {
        ...state,
        activeRouteHistoryStations: {
          ...state.activeRouteHistoryStations,
          items: action.payload.stations,
          pageCount: action.payload.pageCount,
        },
      };
    case SEARCH_ACTIVE_ROUTE_STUDENTS_HISTORY_FAILURE:
      return {
        ...state,
        activeRouteHistoryStudents: {
          ...state.activeRouteHistoryStudents,
          items: [],
          pageCount: 1,
        },
      };
    case SEARCH_ACTIVE_ROUTE_STUDENTS_HISTORY_SUCCESS:
      return {
        ...state,
        activeRouteHistoryStudents: {
          ...state.activeRouteHistoryStudents,
          items: action.payload.students,
          pageCount: action.payload.pageCount,
        },
      };
    case SET_BUS_ROUTES_LOADING: {
      return {
        ...state,
        busRoutesLoading: action.payload.isLoading,
      };
    }
    case SET_DRIVER_ROUTES_LOADING: {
      return {
        ...state,
        driverRoutesLoading: action.payload.isLoading,
      };
    }
    case SET_ROUTE_HISTORY_DELAYS_LOADER:
      return {
        ...state,
        activeRouteHistoryDelays: {
          ...state.activeRouteHistoryDelays,
          loading: action.payload.flag,
        },
      };
    case SET_ROUTE_HISTORY_DETAILS_LOADER:
      return {
        ...state,
        activeRouteHistoryDetails: {
          ...state.activeRouteHistoryDetails,
          loading: action.payload.flag,
        },
      };
    case SET_ROUTE_HISTORY_LOCATIONS_LOADER:
      return {
        ...state,
        activeRouteHistoryLocations: {
          ...state.activeRouteHistoryLocations,
          loading: action.payload.flag,
        },
      };
    case SET_ROUTE_HISTORY_STATIONS_LOADER:
      return {
        ...state,
        activeRouteHistoryStations: {
          ...state.activeRouteHistoryStations,
          loading: action.payload.flag,
        },
      };
    case SET_ROUTE_HISTORY_STUDENTS_LOADER:
      return {
        ...state,
        activeRouteHistoryStudents: {
          ...state.activeRouteHistoryStudents,
          loading: action.payload.flag,
        },
      };
    case SHOW_ROUTE_STATIONS_LOADER: {
      return {
        ...state,
        routeStationsUpdating: true,
      };
    }
    case SHOW_ROUTES_HISTORY_LOADER:
      return {
        ...state,
        activeRoutesHistory: {
          ...state.activeRoutesHistory,
          loading: true,
        },
      };
    case CREATE_NEW_ROUTE_STATION:
    case DELETE_ROUTE_STATION:
    case UPDATE_STATIONS_SCHEDULE:
    case UPDATE_STATION: {
      return {
        ...state,
        isStationUpdatingLoading: true,
      };
    }
    case UPDATE_STATION_SUCCESS: {
      return {
        ...state,
        isStationUpdatingLoading: false,
        isRouteStationModalOpen: false,
      };
    }
    case UPDATE_STATION_FAILURE: {
      return {
        ...state,
        isStationUpdatingLoading: false,
      };
    }
    case TOGGLE_STATION_MODAL: {
      return {
        ...state,
        isRouteStationModalOpen: !state.isRouteStationModalOpen,
      };
    }
    case TOGGLE_ROUTE_MODAL: {
      return {
        ...state,
        isRouteModalOpen: !state.isRouteModalOpen,
      };
    }
    case TOGGLE_COPY_ROUTE_MODAL: {
      return {
        ...state,
        isCopyRouteModalOpen: !state.isCopyRouteModalOpen,
      };
    }
    case ROUTE_MODAL_SUBMITED_SUCCESS: {
      return {
        ...state,
        isRouteModalLoading: false,
        isRouteModalOpen: false,
      };
    }
    case ROUTE_MODAL_SUBMITED_FAILURE: {
      return {
        ...state,
        isRouteModalLoading: false,
      };
    }
    case GET_CAMPUSES_FOR_ROUTES: {
      return {
        ...state,
        isRouteModalLoading: true,
      };
    }
    case GET_CAMPUSES_FOR_ROUTES_SUCCESS: {
      return {
        ...state,
        isRouteModalLoading: false,
        campuses: action.payload.campuses,
      };
    }
    case GET_CAMPUSES_FOR_ROUTES_FAILURE: {
      return {
        ...state,
        isRouteModalLoading: false,
      };
    }
    case CLEAR_CAMPUSES_FOR_ROUTES: {
      return {
        ...state,
        campuses: [],
      };
    }
    case GET_LOG_ROUTE_DATA: {
      return {
        ...state,
        logRouteHistory: {
          ...state.logRouteHistory,
          loading: true,
        },
        loader: true,
      };
    }
    case GET_LOG_ROUTE_DATA_SUCCESS:
      return {
        ...state,
        logRouteHistory: {
          ...state.logRouteHistory,
          entities: action.payload.data,
          pageCount: action.payload.pageCount,
          modal: action.payload.modalData,
          loading: false,
        },
        loader: false,
      };
    case GET_LOG_ROUTE_DATA_FAILURE: {
      return {
        ...state,
        logRouteHistory: {
          ...state.logRouteHistory,
          loading: false,
        },
        loader: false,
      };
    }
    case GET_ROUTE_STOP_DATA: {
      return {
        ...state,
        routeStopData: {
          loading: true,
        },
        loader: true,
      };
    }
    case GET_ROUTE_STOP_DATA_SUCCESS:
      return {
        ...state,
        routeStopData: {
          ...state.routeStopData,
          entities: action.payload.data,
          pageCount: action.payload.pageCount,
          loading: false,
        },
        loader: false,
      };
    case GET_ROUTE_STOP_DATA_FAILURE: {
      return {
        ...state,
        routeStopData: {
          loading: false,
        },
        loader: false,
      };
    }
    case CLEAR_ROUTES_REDUCER:
      return INIT_STATE;

    case UPDATE_SELECTED_ROUTES:
      return {
        ...state,
        selectedRoutes: action.payload,
      };

    default:
      return state;
  }
};
